import { render } from "./vfileclassifyaddlast.vue?vue&type=template&id=2aa386f6&scoped=true"
import script from "./vfileclassifyaddlast.vue?vue&type=script&lang=js"
export * from "./vfileclassifyaddlast.vue?vue&type=script&lang=js"

import "./vfileclassifyaddlast.vue?vue&type=style&index=0&id=2aa386f6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa386f6"]])

export default __exports__